/**
 * Casanuva geld — prijzen opmaken in JS, precies zoals Liquid het doet.
 *
 * Sommige prijzen komen niet uit Liquid maar uit een API: de zoeksuggesties
 * (/search/suggest.json) en de onlangs bekeken producten (/products/x.js).
 * Die geven een kaal getal, dus de opmaak moet in JS gebeuren — en daar ging
 * het mis: de zoekbalk plakte er een euroteken op, ook op een Australische
 * markt, en de onlangs-bekeken-strook had een eigen symbolenlijst waar PLN en
 * CHF niet in stonden.
 *
 * Hier wordt niets geraden. Liquid maakt één voorbeeldbedrag op met dezelfde
 * filter als de rest van de winkel, en daar leiden we de vorm uit af: waar het
 * symbool staat, welk teken de duizendtallen scheidt, welk teken de decimalen,
 * hoeveel decimalen er zijn, en of er een valutacode achteraan hoort. Verandert
 * de markt, dan verandert het voorbeeld mee en klopt de opmaak vanzelf — ook
 * voor een valuta die vandaag nog niet bestaat in deze winkel.
 */
window.cnvGeld = (function () {
  'use strict';

  var VOORBEELD_CENTEN = 1234567890;   // 12.345.678,90 — genoeg cijfers om alle scheidingstekens te tonen

  var vorm = null;

  function lees() {
    if (vorm) return vorm;
    var el = document.getElementById('cnv-geld-config');
    var voorbeeld = '';
    if (el) {
      try { voorbeeld = (JSON.parse(el.textContent) || {}).voorbeeld || ''; } catch (e) { voorbeeld = ''; }
    }

    // Het getal uit het voorbeeld snijden: alles ervoor en erna is opmaak.
    var m = voorbeeld.match(/\d[\d.,   ]*\d/);
    if (!m) {
      // Geen bruikbaar voorbeeld: liever het kale getal dan een verkeerd symbool.
      vorm = { voor: '', na: '', duizend: '', decimaal: '.', decimalen: 2 };
      return vorm;
    }

    var getal = m[0];
    var scheiders = getal.replace(/\d/g, '');
    var laatste = scheiders.slice(-1);
    var staart = laatste ? getal.slice(getal.lastIndexOf(laatste) + 1) : '';

    // Een scheider met twee cijfers erachter is het decimaalteken; drie cijfers
    // erachter is een duizendtalscheiding (¥12,345,679 heeft geen decimalen).
    var decimaal = staart.length === 2 ? laatste : '';
    var duizend = '';
    for (var i = 0; i < scheiders.length; i++) {
      if (scheiders[i] !== decimaal) { duizend = scheiders[i]; break; }
    }

    vorm = {
      voor: voorbeeld.slice(0, m.index),
      na: voorbeeld.slice(m.index + getal.length),
      duizend: duizend,
      decimaal: decimaal || '.',
      decimalen: decimaal ? 2 : 0
    };
    return vorm;
  }

  /** Bedrag in hele eenheden (116.95) → "$116.95 AUD" */
  function opmaak(eenheden) {
    var v = parseFloat(eenheden);
    if (isNaN(v)) return '';
    var f = lees();
    var negatief = v < 0;
    v = Math.abs(v);

    var tekst = f.decimalen === 2 ? v.toFixed(2) : String(Math.round(v));
    var delen = tekst.split('.');
    var heel = delen[0];
    if (f.duizend) heel = heel.replace(/\B(?=(\d{3})+(?!\d))/g, f.duizend);

    return (negatief ? '-' : '') + f.voor + heel + (delen[1] ? f.decimaal + delen[1] : '') + f.na;
  }

  /** Bedrag in centen (11695) → "$116.95 AUD". Zo geeft de Shopify-API het. */
  function opmaakCenten(centen) {
    var c = parseFloat(centen);
    return isNaN(c) ? '' : opmaak(c / 100);
  }

  return { opmaak: opmaak, opmaakCenten: opmaakCenten, VOORBEELD_CENTEN: VOORBEELD_CENTEN };
})();

/* Dit bestand laadt met defer, dus een fetch die vroeg terugkomt kan er eerder
   zijn. Wie dat risico loopt, wacht op dit signaal in plaats van op een kaal
   getal terug te vallen. */
document.dispatchEvent(new CustomEvent('cnv-geld-klaar'));
